<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-02-01 
-->
<template>
  <div>
    <Modal class="message-modal" width="760" v-model="detailModal" title="核销详情" :footer-hide="true" :scrollable="true">
      <div class="cancel-detail" style="position: relative;">
        <Button type="primary" v-if="cancelDetail.printStatus == 1" @click="handlePrint(cancelDetail.verificationCode, cancelDetail.name)" style="position: absolute;top: -56px;left: 100px;">打印核销码</Button>
        <div class="ticket-item">
          <div class="cancel-status">
            <div class="font">核销成功</div>
            <div class="time">{{cancelDetail.createTime}}</div>
          </div>
          <div class="cancel">
            <p>
              <span class="spa1">核销码：</span>
              <span>{{cancelDetail.verificationCode}}</span>
            </p>
            <p>
              <span class="spa1">操作：</span>
              <span>{{cancelDetail.verificationUserName}}</span>
            </p>
          </div>
        </div>
        <div class="detail">
          <div class="row">
            <div class="col">
              <div class="th">票务信息</div>
            </div>
            <div class="col">
              <div class="th">订单信息</div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">门票：</span>
              <span class="spa2">{{cancelDetail.activityTicketTitle}}</span>
            </div>
            <div class="col">
              <span class="spa1">订单号：</span>
              <span class="spa2">{{cancelDetail.orderNumber}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">类型：</span>
              <span class="spa2">{{ cancelDetail.ticketType | dealNeed(ticketTypes)}}</span>
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">参会人：</span>
              <span class="spa2">{{ cancelDetail.name}}</span>
            </div>
            <div class="col">
              <span class="spa1">购票人：</span>
              <span class="spa2">{{ cancelDetail.orderXuserName }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">公司：</span>
              <span class="spa2">{{ cancelDetail.compName }}</span>
            </div>
            <div class="col">
              <span class="spa1">公司：</span>
              <span class="spa2">{{ cancelDetail.orderXuserCompName }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">职务：</span>
              <span class="spa2">{{ cancelDetail.title }}</span>
            </div>
            <div class="col">
              <span class="spa1">职务：</span>
              <span class="spa2">{{ cancelDetail.orderXuserTitle }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">电话：</span>
              <span class="spa2">{{ cancelDetail.mobile }}</span>
            </div>
            <div class="col">
              <span class="spa1">电话：</span>
              <span class="spa2">{{ cancelDetail.orderXuserMobile }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="spa1">绑定时间：</span>
              <span class="spa2">{{ cancelDetail.bindingTime }}</span>
            </div>
            <div class="col">
              <span class="spa1">下单时间：</span>
              <span class="spa2">{{ cancelDetail.orderBuyTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { recorddetail } from '@/service/main.js'
import filter from '@/assets/js/filter'
export default {
  inject: ['handlePrint'],
  data() {
    return {
      filter,
      detailModal: false,
      cancelDetail: {},
      ticketTypes: [
        { id: 1, name: '付费票' },
        { id: 2, name: '免费票' },
        { id: 3, name: '赠送票' },
      ]
    }
  },
  computed: {},
  methods: {
    async getDetail(rowId) {
      let res = await recorddetail({
        id: rowId,
      })
      if (res.code == 0) {
        this.detailModal = true
        this.$set(this.$data, 'cancelDetail', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    
  },
}
</script>
<style lang='stylus' scoped>
.message-modal
  >>>.ivu-modal-mask
    background-color rgba(0, 0, 0, 0.6)
  >>>.ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>>.ivu-modal
    top auto
    .ivu-modal-content
      background #ffffff
      border-radius 0
    .ivu-modal-header-inner
      color #333
      font-size 20px
      font-weight 600
      height 36px
      line-height 36px
    .ivu-modal-close
      top 16px
      .ivu-icon-ios-close
        color #333
        font-size 38px
        &:hover
          color #2c66d2
    .ivu-modal-header
      border-bottom none
      padding 20px
    .ivu-modal-body
      padding 0 20px 40px
.cancel-detail
  .ticket-item
    display flex
    align-items center
    > div
      flex 0 0 350px
      max-width 350px
      min-width 350px
      &+div
        margin-left 20px
  .cancel
    .spa1
      font-weight bold
      color #2E6BF7
  .cancel-status
    color #51C332
    .font
      font-size 46px
      font-weight bold
      line-height 1
    .time
      font-size 16px
      margin-top 10px
  .detail
    margin-top 20px
    .row
      display flex
      > .col
        flex 0 0 350px
        max-width 350px
        min-width 350px
        display flex
        &+.col
          margin-left 20px
      &+.row
        margin-top 20px
    .th
      font-size 16px
      font-weight bold
      color #333333
      position relative
      padding-left 8px
      line-height 1
      line-height 18px
      &::before
        content ''
        position absolute
        width 4px
        height 16px
        background linear-gradient(270deg, #2765F6, #6E99FC)
        border-radius 2px
        left 0
        top 0
    .spa1
      color #666666
      font-weight bold
      word-break keep-all
    .spa2
      color #333333
      font-weight bold
      word-break break-word
</style>